export const canCurrentUserAcceptInvitation = (invitationUserId: string, currentUserId: string): boolean =>
  !!invitationUserId && !!currentUserId && invitationUserId === currentUserId;
